'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sanitizeContent = sanitizeContent;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _require = require('lodash'),
    map = _require.map,
    omit = _require.omit;

function sanitizeContent(_ref) {
  var content = _ref.content,
      rest = _objectWithoutProperties(_ref, ['content']);

  var blocks = map(content.blocks, removeRedundantTextAlignment);
  return _extends({}, rest, {
    content: _extends({}, content, {
      blocks: blocks
    })
  });
}

/*
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */
function removeRedundantTextAlignment(block) {
  return block.type === 'atomic' ? omitTextAlignment(block) : omitLeftTextAlignment(block);
}

function omitLeftTextAlignment(block) {
  return block.data.textAlignment === 'left' ? omitTextAlignment(block) : block;
}

function omitTextAlignment(block) {
  return omit(block, 'data.textAlignment');
}